import React, { useState, useEffect } from "react";
import "./AddDepartment.css";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import Header from "../../../Components/Dashboard/Header/Header";
import { GetToken, Apiurl } from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Modal } from "react-bootstrap";

const AdminDepartment = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [department, setDepartment] = useState("");
  const [departments, setDepartments] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingName, setEditingName] = useState("");
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const LoginToken = GetToken();
      const response = await axios.get(`${Apiurl()}/Admin/GetDepartments`, {
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          authorization: `Bearer ${LoginToken}`,
        },
      });

      let deptData = response?.data?.data;
      if (typeof deptData === "string") deptData = JSON.parse(deptData);
      if (!Array.isArray(deptData)) deptData = deptData ? [deptData] : [];
      setDepartments(deptData);
    } catch (error) {
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const GetProfile = async () => {
      try { 
        const LoginToken = GetToken();
        await axios.get(`${Apiurl()}/Profile/GetProfile`, {
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },
        });

        await fetchDepartments();
      } catch (error) {
        toast.error("Failed to load profile");
      }
    };

    GetProfile();
  }, []);

  const handleSave = async () => {
    if (!department.trim()) {
      toast.error("Please enter a department name.");
      return;
    }

    setLoading(true);
    const LoginToken = GetToken();
    const dataObj = { Name: department };

    try {
      const response = await axios.post(
        `${Apiurl()}/Admin/SaveDepartMent`,
        { Data: JSON.stringify(dataObj) },
        {
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },
        }
      );

      if (response?.status === 200) {
        toast.success(response?.data?.message || "Department saved successfully!");
        setDepartment("");
        await fetchDepartments();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save department");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditingName(departments[index]?.Name || departments[index]?.DepartmentName || "");
  };

  const handleUpdate = async (index) => {
    if (!editingName.trim()) {
      toast.error("Department name cannot be empty.");
      return;
    }

    const deptToUpdate = departments[index];
    const deptId = deptToUpdate?.Id || deptToUpdate?.DepartmentId || deptToUpdate?.id;

    if (!deptId) {
      toast.error("Department ID not found. Please refresh and try again.");
      return;
    }

    setLoading(true);
    const LoginToken = GetToken();
    const dataObj = { Id: deptId, Name: editingName };

    try {
      const response = await axios.post(
        `${Apiurl()}/Admin/SaveDepartMent`,
        { Data: JSON.stringify(dataObj) },
        {
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },
        }
      );

      if (response?.status === 200) {
        toast.success(response?.data?.message || "Department updated successfully!");
        setEditingIndex(null);
        setEditingName("");
        await fetchDepartments();
      }
    } catch (error) {
      if (error?.code === "ERR_NETWORK") {
        toast.error("Network error. The server might not support this operation.");
      } else {
        toast.error(error?.response?.data?.message || "Failed to update department");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (index) => {
    const deptToDelete = departments[index];
    const deptId = deptToDelete?.Id || deptToDelete?.DepartmentId || deptToDelete?.id;

    if (!deptId) {
      toast.error("Department ID not found. Please refresh and try again.");
      return;
    }

    setLoading(true);
    const LoginToken = GetToken();
    const dataObj = { Id: deptId };

    try {
      const response = await axios.post(
        `${Apiurl()}/Admin/DeleteDepartment`,
        { Data: JSON.stringify(dataObj) },
        {
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },
        }
      );

      if (response?.status === 200) {
        toast.success(response?.data?.message || "Department deleted successfully!");
        await fetchDepartments();

        if (editingIndex === index) {
          setEditingIndex(null);
          setEditingName("");
        }
      }
    } catch (error) {
      if (error?.code === "ERR_NETWORK") {
        toast.error("Network error. Please check your connection and try again.");
      } else {
        toast.error(error?.response?.data?.message || "Failed to delete department");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditingName("");
  };

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-page-annoucement"
              : "main-container-of-all-employees-page-annoucement-new"
          }
        >
          <div className="admin-page-content">
            {loading ? (
              <div style={{ padding: "20px", textAlign: "center" }}>Loading...</div>
            ) : (
              <>
                <div className="subdept-header-container">
                  <div className="all-employee-text-annoucement">
                    <h4>Department</h4>
                  </div>

                  <div className="all-employees-directory-annoucement">
                    <div className="home-icon-header-annoucement">
                      <BiHomeAlt className="home-icon-header-annoucement" />
                    </div>
                    <div className="arrow-icon-header-annoucement">
                      <MdKeyboardArrowRight />
                    </div>
                    <div className="employee-text-header-annoucement">
                      <p>Dashboard</p>
                    </div>
                    <div className="arrow-icon-header-profile">
                      <MdKeyboardArrowRight />
                    </div>
                    <div className="all-employee-text-header-annoucement">
                      <p>Add Departments</p>
                    </div>
                  </div>
                </div>

                <div className="outer-div-of-username-password-annoucement">
                  <div className="security-annoucement">
                    <h5>Manage Department</h5>
                  </div>

                  <div className="username-password-announcement">
                    <div className="row">
                      <div className="col-md-6 username-content-annoucement">
                        <div className="flash-floating-annoucement">
                          <label>Department Name</label>
                          <input
                            type="text"
                            className="abcd"
                            placeholder="Enter department"
                            value={department}
                            onChange={(e) => setDepartment(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="save-button-in-setting-annoucement">
                      <button
                        className="save-button-in-setting-annoucement-button-one"
                        onClick={handleSave}
                        disabled={loading}
                      >
                        Save
                      </button>
                      <button
                        className="save-button-in-setting-annoucement-button-two"
                        onClick={() => setDepartment("")}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>

                  <div className="department-table-container">
                    <h5 style={{ textAlign: "center", margin: "12px 0" }}>Departments List</h5>

                    <div className="subdept-table-wrapper">
                      <table className="subdept-table">
                        <thead>
                          <tr>
                            <th>Id No.</th>
                            <th>Department Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {departments.length > 0 ? (
                            departments.map((dept, index) => (
                              <tr key={dept?.Id || dept?.DepartmentId || index}>
                                <td>{index + 1}</td>

                                <td>
                                  {editingIndex === index ? (
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={editingName}
                                      onChange={(e) => setEditingName(e.target.value)}
                                    />
                                  ) : (
                                    dept?.Name || dept?.DepartmentName || "N/A"
                                  )}
                                </td>

                                <td>
                                  <div className="dept-action-wrap">
                                    {editingIndex === index ? (
                                      <>
                                        <button
                                          className="btn btn-success btn-sm me-2"
                                          onClick={() => handleUpdate(index)}
                                          disabled={loading}
                                        >
                                          Update
                                        </button>
                                        <button
                                          className="btn btn-secondary btn-sm"
                                          onClick={handleCancelEdit}
                                        >
                                          Cancel
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        <button
                                          className="btn btn-primary btn-sm me-2"
                                          onClick={() => handleEdit(index)}
                                        >
                                          Edit
                                        </button>
                                        <button
                                          className="btn btn-danger btn-sm"
                                          onClick={() => {
                                            setDeleteIndex(index);
                                            setShowDeleteModal(true);
                                          }}
                                          disabled={loading}
                                        >
                                          Delete
                                        </button>
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" style={{ textAlign: "center" }}>
                                No departments found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setDeleteIndex(null);
        }}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to delete this department?</p>
          <strong>
            {deleteIndex !== null &&
              (departments[deleteIndex]?.Name || departments[deleteIndex]?.DepartmentName)}
          </strong>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowDeleteModal(false);
              setDeleteIndex(null);
            }}
          >
            Cancel
          </button>

          <button
            className="btn btn-danger"
            onClick={() => {
              handleDelete(deleteIndex);
              setShowDeleteModal(false);
              setDeleteIndex(null);
            }}
          >
            Yes, Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminDepartment;